import React from 'react'
import heroImg from '../assets/images/hero.svg'
import CountUp from 'react-countup';
import image1 from '../assets/images/main_hero.png'
import Shineyeffect from './Shineyeffect'
function Hero() {
  return (
    <section className='pt-0 overflow-x-hidden' id='about'>
        <div className='container pt-14 '>
            <div className='md:flex items-center justify-between sm:flex-col md:flex-row'>
                {/** Hero Left Content  */}
                <div className='w-full md:basis-1/2 '>
                    <h5 data-aos='fade-right' 
                        data-aos-duration='2000' 
                        className='text-gray-600 font-[600] text-[16px]'
                        >Hello welcome</h5>
                    <h1 data-aos="fade-up"
                        data-aos-duration='100'
                        className='text-sky-500 font-[800] text-[1.8rem] sm:text-[40px] leading-[35px] sm:leading-[46px] mt-5'
                        >I'm Youcef Bada <br/>Software developer </h1>
                    <div 
                        data-aos="fade-up"
                        data-aos-duration='2000'
                        data-aos-delay="200"
                        className='flex items-center gap-6 mt-7'> 
                        <a href="#Contact">
                          <button className='bg-sky-800 text-white font-[500] flex item-center gap-2 ease-in duration-300 
                          py-2 px-4 rounded-[8px]'> 
                            <i class='ri-mail-line'></i>Hire Me</button>
                        </a>
                        <a href="#portfolio" className='text-sky-800 font-[600] text-[16px] py-2 px-4 border border-sky-800 rounded-xl'>See Portfolio</a>
                    </div>
                    <p className='flex gap-3  text-gray-800  text-[15px] leading-7 py-5 '
                            data-aso="fade-left"
                            data-aos-duration="1500"
                        >
                          <span>
                            <i class='ri-apps-2-line'></i>
                          </span>
                          "Youcef Bada: Expert in Automation & Web Scraping. Proficient in both Front & Back End Development. Specializing in crafting seamless user experiences and leveraging automation for effective marketing strategies.
                    </p>
                    <div className='flex items-center gap-6 mt-14 '>
                      <span className='text-sky-500 text-[15px] font-[600]'>
                        Follow Me : 
                      </span>
                      <span>
                        <a href="https://github.com/Youcefbada" className='text-sky-500 text-[15px] font-[600] '><i className='ri-github-line'></i></a>
                      </span>
                      <span>
                        <a href="https://www.facebook.com/profile.php?id=100045614194342" className='text-sky-500 text-[15px] font-[600] '><i className='ri-facebook-line'></i></a>
                      </span>
                      <span>
                        <a href="https://www.instagram.com/youcef__bada" className='text-sky-500 text-[15px] font-[600] '><i className='ri-instagram-line'></i></a>
                      </span>
                    </div>
                </div>
                {/**    Hero image   */}
                <div className='basis-1/3 mt-10 sm:mt-0 '>
                  <figure className='flex items-center justify-center '>
                    <img src={image1} alt="My image here"/>
                  </figure>
                </div>
                {/** Hero content right  */}

            </div>
            <div className='hidden md:block'>
                <Shineyeffect left={0} top={0} size={1200}/>
                <Shineyeffect left={0} top={0} size={1200}/>
                <Shineyeffect left={0} top={0} size={1200}/>

            </div>
        </div>
    </section>
  )
}

export default Hero